module.exports = __webpack_public_path__ + "img/4.e32c2348.jpg";